import constants from '../shared/constants';

window.addEventListener('error', (event: Event): void => {
    const target = event.target;

    if (!(target instanceof HTMLImageElement) || !target.matches(constants.targets.imageFallback)) {
        return;
    }

    const backgroundColor = target.getAttribute(constants.attributes.imageFallbackBackground);

    if (!backgroundColor) {
        return;
    }

    target.style.backgroundColor = backgroundColor;
}, true);
